import comp from "./AlertCard";
export default comp;
